<template>
  <div
    class="px-10 md:px-24 pt-3"
  >
    <settings-header
      active-tab="advanced"
      :entity-id="entity.id"
    />
    <div class="mt-10">
      <div>
        <h1
          class="text-xl text-left text-sc-gray-dark"
        >
          {{ $t('message.settings.advancedTab.movementsNumber.title') }}
        </h1>
        <div>
          <div class="flex mt-5">
            <input
              type="text"
              ref="movements-number-input"
              v-model="newMovementsNumber"
              :placeholder="movementsNumber"
              class="w-24 px-2 py-1 text-sm text-center bg-white rounded text-primary shadow-sc-button focus:outline-none"
            >
            <button
              ref="movements-number-button"
              class="inline-block px-3 py-1 ml-5 text-sm leading-5 text-center text-white rounded bg-sc-blue hover:text-white"
              @click="updateMovementsNumber()"
            >
              {{ $t('message.settings.advancedTab.movementsNumber.save') }}
            </button>
          </div>
          <p class="text-sm text-sc-red">
            {{ movementsNumberError }}
          </p>
        </div>
        <h1 class="mt-5 text-xl text-left text-sc-gray-dark">
          {{ $t('message.settings.advancedTab.balances') }}
        </h1>
        <div class="w-full md:w-56 mt-2">
          <div class="flex justify-between">
            <h1
              class="text-sm text-left text-sc-gray-dark"
            >
              {{ $t('message.settings.advancedTab.availableBalance') }}
            </h1>
            <b-checkbox
              v-model="availableBalancesConfiguration"
            />
          </div>
          <div class="flex justify-between pt-2">
            <h1
              class="text-sm text-left text-sc-gray-dark"
            >
              {{ $t('message.settings.advancedTab.totalBalance') }}
            </h1>
            <b-checkbox
              v-model="totalBalancesConfiguration"
            />
          </div>
          <div class="flex justify-between pt-2">
            <h1
              class="text-sm text-left text-sc-gray-dark"
            >
              {{ $t('message.settings.advancedTab.pendingBalance') }}
            </h1>
            <b-checkbox
              v-model="pendingBalancesConfiguration"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="pb-20 md:pb-0 mt-5">
      <h1
        class="text-xl text-left text-sc-gray-dark"
      >
        {{ $t('message.settings.advancedTab.deleteEntity') }}
      </h1>
      <div class="mt-5">
        <b-loading
          :is-full-page="false"
          v-model="loading"
        />
        <button
          class="block px-3 py-1 mb-0 text-sm leading-5 text-center text-white rounded bg-sc-red hover:text-white shadow-sc-button"
          @click="showDeleteEntityModal()"
          ref="deleteEntityButton"
        >
          {{ $t('message.settings.advancedTab.deleteButton') }}
        </button>
        <p
          v-if="deleteEntityError"
          class="block mt-1 text-xs text-red-700 "
        >
          {{ deleteEntityError }}
        </p>
      </div>
    </div>
    <confirmation-modal
      name="delete-entity-modal"
      ref="deleteEntityModal"
      :content="`¿Está seguro que desea eliminar esta supercartola
                  ${entity.name}?`"
      :flip-buttons-style="true"
      :is-approval-modal="false"
      @confirmation="deleteEntity"
    />
  </div>
</template>

<script>
import EntitiesApi from '../api/entities';
import EntityConfigurationsApi from '../api/entity_configurations';
import ConfirmationModal from './confirmation-modal.vue';
import SettingsHeader from './settings-header.vue';

export default {
  data() {
    return {
      loading: false,
      deleteEntityError: false,
      movementsNumber: null,
      newMovementsNumber: null,
      movementsNumberError: '',
      balancesConfiguration: {},
    };
  },
  components: {
    ConfirmationModal,
    SettingsHeader,
  },
  props: {
    entity: {
      type: Object,
      required: true,
    },
  },
  beforeMount() {
    this.$store.dispatch('setEntityId', this.entity.id);
    this.reloadConfiguration();
  },
  computed: {
    availableBalancesConfiguration: {
      get() {
        return this.$store.state.entities.balancesConfiguration.available;
      },
      set(value) {
        this.updateBalancesConfiguration('available', value);
      },
    },
    pendingBalancesConfiguration: {
      get() {
        return this.$store.state.entities.balancesConfiguration.pending;
      },
      set(value) {
        this.updateBalancesConfiguration('pending', value);
      },
    },
    totalBalancesConfiguration: {
      get() {
        return this.$store.state.entities.balancesConfiguration.total;
      },
      set(value) {
        this.updateBalancesConfiguration('total', value);
      },
    },
  },
  methods: {
    reloadConfiguration() {
      this.$store.dispatch('getEntityConfiguration').then(() => {
        this.entityConfiguration = this.$store.state.entities.entityConfiguration;
        this.movementsNumber = this.entityConfiguration.movementsNumber;
        this.balancesConfiguration = this.$store.state.entities.balancesConfiguration;
      });
    },
    showDeleteEntityModal() {
      this.$refs.deleteEntityModal.show();
    },
    async deleteEntity() {
      this.loading = true;
      try {
        await EntitiesApi.deleteEntity(this.entity.id);
        window.location.href = '/';
      } catch (error) {
        this.deleteEntityError = 'Ocurrió un error al eliminar la supercartola';
      }
      this.loading = false;
    },
    async updateMovementsNumber() {
      const entityConfiguration = this.$store.state.entities.entityConfiguration;
      try {
        await EntityConfigurationsApi.updateMovementsNumber(entityConfiguration.id,
          this.newMovementsNumber);
        this.movementsNumber = this.newMovementsNumber;
        this.newMovementsNumber = '';
        this.movementsNumberError = '';
      } catch (error) {
        this.movementsNumberError = error.message;
      }
    },
    updateBalancesConfiguration(balanceName, value) {
      this.balancesConfiguration[balanceName] = value;
      EntitiesApi.updateBalancesConfiguration(this.entity.id, { ...this.balancesConfiguration });
    },
  },
};
</script>
